<script setup lang="ts">
defineProps({
    tech: {
        type: Object,
        required: true,
    },
})

const { element, handleMove, handleOut } = useFloatingCard()
</script>

<template>
    <figure ref="element" @mousemove="handleMove" @mouseout="handleOut"
        class="flex flex-col items-center justify-center"
        :class="['xs:p-4 rounded-lg p-2 sm:p-6', 'flex flex-col items-center', 'hover:bordershadow-lg-gray hover:bg-white']"
    :style="{ transition: 'box-shadow 0.1s, transform 0.1s, background 0.1s' }"
  >
        <img :src="tech.image.url" :alt="tech.image.alternativeText || tech.image.name" :title="tech.name"
            class="h-10 object-contain pointer-events-none" />
        <figcaption class="mt-4 text-sm text-gray-400 pointer-events-none text-center">
            {{ tech.name }}
        </figcaption>
    </figure>
</template>
